import React from 'react';
import { connect } from 'react-redux';
import ReportsPage from '../index';
import authContainer from '../../../../containers/auth';


const ManagerReportsPage = (props) => {
  const isHrRole = props.user.role.some(role => role === 'HR');

  return (
    <ReportsPage isManagerReport isHrReport={isHrRole} reportPermissionUnitIds={props.user.reportPermissionUnitIds} />
  );
};
export default connect(...authContainer)(ManagerReportsPage);



// WEBPACK FOOTER //
// ./src/pages/travel-expense/reports/manager/index.js